define(
    'viewmodels/secured/libraries/create/fromTemplate/select/select',[
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (
        ViewModel,
        dataProvider,
        i19n
        ){

        var vm = new ViewModel(
        {
            details: function(
                description,
                fields,
                list,
                template
                ){
                    this.createanewemptylibraryusingtheblueprint2(description);
                    this.createanewemptylibraryusingtheblueprint3(String.format(i19n.to.createanewemptylibraryusingtheblueprint3, fields));
                    this.createanewemptylibraryusingtheblueprint4(String.format(i19n.to.createanewemptylibraryusingtheblueprint4, list));
                    this.createanewemptylibraryusingtheblueprint5(String.format(i19n.to.createanewemptylibraryusingtheblueprint5, template));
                },
            i19n: i19n,

            title: ko.observable(''),
            createanewemptylibraryusingtheblueprint2: ko.observable(''),
            createanewemptylibraryusingtheblueprint3: ko.observable(''),
            createanewemptylibraryusingtheblueprint4: ko.observable(''),
            createanewemptylibraryusingtheblueprint5: ko.observable('')
        });

        vm.activate = function () {
        };
        vm.attached = function () {
        };

        return vm;
    }
);
